/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const $select = $( '.archive-ll_treatment__filters select' );

      $select.on( 'change', function() {
        const selected = $( this ).val();

        if ( selected !== '' ) {
          $( '.archive-ll_treatment__category-group' ).hide();
          $( '.archive-ll_treatment__category-group[data-category="' + selected + '"]' ).show();
        } else {
          $( '.archive-ll_treatment__category-group' ).show();
        }

        $( '.archive-ll_treatment__category-group' ).each( function() {
          if ( $( this ).find( '.category:visible' ).length === 0 ) {
            $( this ).hide();
          }
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'treatments', COMPONENT );
} )( app );
